<div class="container p-5">
    <div class="row">
        <h1 class="mb-1">Set your recipient</h1>
        <h4 class="mb-0">These represent the people that your assistant can transfer the call to</h4>
    </div>

    <div class="row">
        <div class="col-12 d-flex justify-content-end">
            <button mat-raised-button (click)="onAddTransfer()">
                <mat-icon>add</mat-icon>
                Add recipient
            </button>
        </div>
    </div>

    <!-- Filter -->
    <div class="row">
        <div class="col-12">
            <mat-form-field appearance="fill" class="w-100 mt-5">
                <mat-label>Filter By name</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
                <mat-icon matPrefix>search</mat-icon>
            </mat-form-field>
        </div>
    </div>

    <!-- List of recipients -->

    <div class="row">
        <div class="col-4" *ngFor="let recipient of filteredRecipients; let i = index">
            <div class="mat-elevation-z2 d-flex flex-column justify-content-around align-items-center rounded p-3">
                <div class="d-flex align-items-center justify-content-center">
                    <mat-icon class="me-1 mb-2">phone_in_talk</mat-icon>
                    <p class="fw-bold text-decoration-underline">{{recipient.name}}</p>
                </div>
                <p class="mt-2"><span class="fw-bold">Phone Number: </span>{{recipient.phoneNumber}}</p>
                <button class="mt-4 mb-1 w-75" [disabled]="isLoadingArray[i]" mat-raised-button
                    (click)="onEditTransfer(recipient)">Edit</button>
                <button color="warn w-75" [disabled]="isLoadingArray[i]" mat-raised-button
                    (click)="onDeleteTransfer(recipient, i)">
                    <span *ngIf="!isLoadingArray[i]">
                        Remove
                    </span>
                    <mat-spinner *ngIf="isLoadingArray[i]" [diameter]="30" [strokeWidth]="3"
                        class="mx-auto mat-spinner"></mat-spinner>
                </button>
            </div>
        </div>
    </div>

    <h1 class="fw-light text-center mt-5" *ngIf="aiAgent && aiAgent.transferRecipients.length == 0">Click add recipient
        to add one</h1>
</div>